export default __webpack_public_path__ + "static/subset-UniNeueRegular-806fe4b90022c16e4c1b8453f7e06803.woff";